/* @ngInject */
const AppRun = (
    $ionicPlatform,
    $cordovaStatusbar,
    $cordovaKeyboard,
    $rootScope,
    localStorageService,
    $translate,
    Restangular,
    $ionicLoading,
    ApiUser,
    $state,
    $timeout,
    ApiNotifications,
    $cordovaNetwork,
    $ionicPopup,
    $ionicConfig,
    TaskMutationTrackingService
) => {
    // $rootScope.isMobile = false,

    $ionicPlatform.ready(() => {
        if (
            window.cordova &&
            window.cordova.plugins &&
            window.cordova.plugins.Keyboard
        ) {
            cordova.plugins.Keyboard.hideKeyboardAccessoryBar(false);
            cordova.plugins.Keyboard.disableScroll(true);
        }

        if (window.StatusBar) {
            $cordovaStatusbar.style(1);
        }

        if (navigator.splashscreen) {
            navigator.splashscreen.hide();
        }

        if (window.cordova && $cordovaNetwork.isOffline()) {
            $ionicPopup.alert({
                title: '<b>Offline</b>',
                template:
                    'advinda needs internet connection and cannot run offline',
                okType: 'button-picton-blue',
            });
        }
    });

    const isTableSmall = () => {
        if (window.innerWidth <= 600) {
            return true;
        } else {
            return false;
        }
    };

    const isSmallScreen = () => {
        if (window.innerWidth < 1024) {
            return true;
        } else {
            return false;
        }
    };

    const isMobileView = () => {
        if (ionic.Platform.isIOS() || ionic.Platform.isAndroid()) {
            return true;
        } else {
            return false;
        }
    };

    const isDataTapDisabled = () => {
        return !isMobileView() && !isSmallScreen();
    };

    const isAndroid = () => {
        if (ionic.Platform.isAndroid()) {
            return true;
        } else {
            return false;
        }
    };

    const isIos = () => {
        if (ionic.Platform.isIOS()) {
            return true;
        } else {
            return false;
        }
    };

    const isPortraitMode = () => {
        if (window.orientation == 90 || window.orientation == -90) {
            return true;
        } else {
            return false;
        }
    };

    const isIosApp = () => {
        return ionic.Platform.isWebView() && ionic.Platform.isIOS();
    };

    const isIE = /*@cc_on!@*/ false || !!document.documentMode;

    const helpUri = 'https://advinda.com/help/';
    const helpIosUri = 'https://advinda.com/ios-help/';
    const termsIosUrl = 'https://advinda.com/app-termsofservice';
    $rootScope.platform = ionic.Platform.platform();
    $rootScope.isSmallScreen = isSmallScreen();
    $rootScope.isMobileView = isMobileView();
    $rootScope.isTableSmall = isTableSmall();
    $rootScope.isDataTapDisabled = isDataTapDisabled();
    $rootScope.isAndroid = isAndroid();
    $rootScope.isIos = isIos();
    $rootScope.isWebView = ionic.Platform.isWebView();
    $rootScope.isMobileWebBrowser = isMobileView() && !$rootScope.isWebView;
    $rootScope.isIE = /*@cc_on!@*/ false || !!document.documentMode;
    $rootScope.isPortraitMode = isPortraitMode();
    $rootScope.isIosApp = isIosApp();

    $rootScope.openHelp = (event) => {
        event.preventDefault();
        if (!window.cordova) {
            window.open(helpUri, '_blank');
        } else if (isIos()) {
            window.cordova.InAppBrowser.open(helpIosUri, '_blank');
        } else {
            window.cordova.InAppBrowser.open(helpUri, '_blank');
        }
    };

    $rootScope.openInBrowser = (event, url) => {
        event.preventDefault();
        window.cordova.InAppBrowser.open(url, '_blank');
    };

    window.addEventListener('resize', updateRoot);
    window.addEventListener(
        'orientationchange',
        function () {
            if (window.orientation == 90 || window.orientation == -90) {
                $rootScope.isPortraitMode = true;
            } else {
                $rootScope.isPortraitMode = false;
            }
            $rootScope.$apply();
        },
        false
    );

    function updateRoot() {
        var bool = isSmallScreen();
        if ($rootScope.isSmallScreen !== bool) {
            $rootScope.isSmallScreen = isSmallScreen();
        }

        bool = isTableSmall();
        if ($rootScope.isTableSmall !== bool) {
            $rootScope.isTableSmall = isTableSmall();
        }

        bool = isDataTapDisabled();
        if ($rootScope.isDataTapDisabled !== bool) {
            $rootScope.isDataTapDisabled = isDataTapDisabled();
        }
    }

    // Set language from localStorage if existing
    $translate.use(localStorageService.get('localeToUse'));

    $rootScope.$on(
        '$stateChangeStart',
        function (event, toState, toParams, fromState, fromParams) {
            $translate.use(localStorageService.get('localeToUse'));
            $ionicConfig.scrolling.jsScrolling(true);

            if (
                TaskMutationTrackingService.canTriggerTaskMutation(
                    fromState,
                    toState
                )
            ) {
                TaskMutationTrackingService.storeMutationTriggeringStateInSessionStore(
                    toState,
                    toParams
                );
            }
        }
    );

    // Restangular interceptor
    Restangular.setFullRequestInterceptor(
        (element, operation, route, url, headers, params) => {
            const currentHeaders = headers;
            currentHeaders.Authorization =
                'Bearer ' + localStorageService.get('token');

            return {
                element: element,
                params: params,
                headers: currentHeaders,
            };
        }
    );

    function loggedIn() {
        if (localStorageService.get('token')) {
            return true;
        } else {
            return false;
        }
    }

    $rootScope.isLoggedIn = loggedIn();

    (function () {
        // This is also called in the login controller. It must be done in 2 places to update the user by login and when the page reloads (F5).
        if ($rootScope.isLoggedIn && !$rootScope.user) {
            ApiUser.getUser()
                .then((res) => {
                    if (typeof res != 'undefined') {
                        $rootScope.user = res;
                    }
                })
                .then(() => {
                    getNotifications();
                });
        }
    })();

    $rootScope.$on(
        '$stateChangeSuccess',
        function (event, toState, toParams, fromState, fromParams) {
            $rootScope.pageTitle = undefined;
            $rootScope.$state = toState;
            getNotifications();
            resetSelectedTabInTaskPage(fromState, toState);
        }
    );

    function getNotifications() {
        if (loggedIn() && $rootScope.user) {
            ApiNotifications.getNotifications().then((res) => {
                $rootScope.notificationCount = res;
            });
        }
    }

    function resetSelectedTabInTaskPage(fromState, toState) {
        if (fromState.name) {
            if (
                fromState.name === 'campaignDetail' &&
                toState.name !== 'taskDetail'
            ) {
                sessionStorage.removeItem('task-tab');
            } else if (
                fromState.name === 'tasks' &&
                toState.name !== 'taskDetail'
            ) {
                sessionStorage.removeItem('task-tab');
            } else if (
                fromState.name === 'contactsDetail' &&
                toState.name !== 'taskDetail'
            ) {
                sessionStorage.removeItem('task-tab');
            } else if (
                fromState.name === 'investorsDetail' &&
                toState.name !== 'taskDetail'
            ) {
                sessionStorage.removeItem('task-tab');
            } else if (
                fromState.name === 'campaignContactDetail' &&
                toState.name !== 'taskDetail'
            ) {
                sessionStorage.removeItem('task-tab');
            }
        }
    }

    $rootScope.openIOSTerm = (event) => {
        event.preventDefault();
        if (window.cordova) {
            window.cordova.InAppBrowser.open(termsIosUrl, '_system');
        }
    };
};

export default AppRun;



/** WEBPACK FOOTER **
 ** ./src/app/app.run.js
 **/